var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3336 23.25L12.1748 13.7925L16.2503 7L24.9169 23.25H17.3336ZM8.66693 11.3333L15.1669 23.25H2.16693L8.66693 11.3333ZM5.9586 9.16667C5.2403 9.16667 4.55143 8.88133 4.04352 8.37341C3.53561 7.8655 3.25026 7.17663 3.25026 6.45833C3.25026 5.74004 3.53561 5.05116 4.04352 4.54325C4.55143 4.03534 5.2403 3.75 5.9586 3.75C6.67689 3.75 7.36577 4.03534 7.87368 4.54325C8.38159 5.05116 8.66693 5.74004 8.66693 6.45833C8.66693 7.17663 8.38159 7.8655 7.87368 8.37341C7.36577 8.88133 6.67689 9.16667 5.9586 9.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogoWhite);
export default __webpack_public_path__ + "static/media/brand-logo-white.6971cc3734f0319c84c5c318064500c7.svg";
export { ForwardRef as ReactComponent };